module.exports = __webpack_public_path__ + "img/law1-m@1.f8a024c0.jpg";